export default "__VITE_ASSET__BEqis2Rs__"